// km-api/errorMapper.js
// Mappa gli errori HTTP secondo la Specifica Tecnica v1.1, §9.1.
// Body atteso dal backend: { detail: string }.
// Non logga mai token, PII o contenuti liberi (Specifica v1.1, §4.3).

export class KmApiError extends Error {
  constructor({ status, code, detail, technicalMessage, correlationId }) {
    super(detail || technicalMessage || `Errore KM API (${status})`);
    this.name = 'KmApiError';
    this.status = status;
    this.code = code;
    this.detail = detail;
    this.technicalMessage = technicalMessage;
    this.correlationId = correlationId;
  }
}

/**
 * Classifica lo status HTTP secondo la mappa §9.1 e restituisce
 * un'azione UI suggerita, senza prescrivere il componente.
 */
const ACTIONS_BY_STATUS = {
  401: 'REAUTH', // avviare login/rinnovo; non perdere una bozza locale
  403: 'FORBIDDEN', // messaggio contestuale, nessun retry automatico
  404: 'NOT_FOUND', // stato vuoto, ritorno alla lista
  409: 'CONFLICT', // ricaricare il record; non sovrascrivere né duplicare
  422: 'VALIDATION', // errori vicino ai campi se il dettaglio lo consente
  500: 'UNEXPECTED', // messaggio generico + correlation id se presente
  502: 'DEPENDENCY_UNAVAILABLE',
  503: 'DEPENDENCY_UNAVAILABLE',
};

export function classifyStatus(status) {
  return ACTIONS_BY_STATUS[status] || (status >= 500 ? 'UNEXPECTED' : 'UNKNOWN');
}

/**
 * Costruisce un KmApiError a partire dalla Response fetch.
 * Non lancia: ritorna l'errore, il chiamante decide se rilanciarlo.
 */
export async function mapResponseError(response) {
  const correlationId = response.headers.get('x-correlation-id') || null;
  let detail;
  try {
    const body = await response.json();
    detail = typeof body?.detail === 'string' ? body.detail : undefined;
  } catch {
    detail = undefined;
  }
  return new KmApiError({
    status: response.status,
    code: classifyStatus(response.status),
    detail,
    technicalMessage: `HTTP ${response.status} su ${response.url}`,
    correlationId,
  });
}

/**
 * Errori di rete/timeout (fetch fallita prima di ricevere una response).
 */
export function mapNetworkError(err, { timedOut = false } = {}) {
  return new KmApiError({
    status: 0,
    code: timedOut ? 'TIMEOUT' : 'NETWORK',
    detail: undefined,
    technicalMessage: timedOut ? 'Timeout richiesta' : (err?.message || 'Errore di rete'),
  });
}
